import { render, staticRenderFns } from "./photo_list.vue?vue&type=template&id=c871769a&scoped=true"
import script from "./photo_list.vue?vue&type=script&lang=js"
export * from "./photo_list.vue?vue&type=script&lang=js"
import style0 from "./photo_list.vue?vue&type=style&index=0&id=c871769a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c871769a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c871769a')) {
      api.createRecord('c871769a', component.options)
    } else {
      api.reload('c871769a', component.options)
    }
    module.hot.accept("./photo_list.vue?vue&type=template&id=c871769a&scoped=true", function () {
      api.rerender('c871769a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/travel_promotion/form/photo_list.vue"
export default component.exports